import { CheckCircle2 } from "lucide-react";
import { useLingui } from "@lingui/react/macro";

export function RecipeReadyToPublishBanner() {
  const { t } = useLingui();

  return (
    <div className="flex items-center overflow-hidden rounded-[8px] border border-(--color-status-active)/30 bg-(--color-success)/10 p-3">
      <div className="flex flex-1 items-center gap-3">
        <div className="flex shrink-0 items-center rounded-[8px] bg-(--color-status-active) p-3">
          <CheckCircle2 className="size-6 text-white" />
        </div>
        <div className="flex flex-col gap-1">
          <p className="text-base font-medium text-(--color-text-primary) leading-none">
            {t`Ready to Publish`}
          </p>
          <p className="text-sm text-(--color-text-secondary) leading-none">
            {t`All required information has been completed. You can now publish the recipe.`}
          </p>
        </div>
      </div>
    </div>
  );
}
